export const getPOCFields = () =>
    `query getPOCFields {
      attributes {
        attribute
        mandatory
      }
    }`;
